<template>
    <div>
        <el-form
            :model="ruleForm"
            ref="ruleForm"
            label-width="160px"
            class="demo-ruleForm">
        <Lineconbgtir :labelcontainer="labelcontaineragain" style="margin-top: 20px"/>
        <div style="display: flex; margin-top: 16px">
            <div>
                <div style="display: flex">
                    <div>
                        <div class="tablebox">
                            <div class="thbox-857">
                                <div class="tdbox">账号名称<span style="color: #FF4D4D">*</span></div>
                                <div class="tdbox" style="padding-left: 17px;">{{ ruleForm.name }}</div>
                            </div>
                        </div>
                        <div class="tablebox">
                            <div class="thbox-857">
                                <div class="tdbox">企业名称<span style="color: #FF4D4D">*</span></div>
                                <div class="tdbox">
                                    <el-input v-model="ruleForm.enterprise_name" size="small" class="inpyabeb" placeholder="请输入企业名称"></el-input>
                                </div>
                            </div>
                        </div>
                        <div class="tablebox">
                            <div class="thbox-857">
                                <div class="tdbox">单位地址<span style="color: #FF4D4D">*</span></div>
                                <div class="tdbox">
                                    <el-input v-model="ruleForm.address" size="small" class="inpyabeb" placeholder="请输入单位地址"></el-input>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="tablebox">
                        <div class="thbox-289">
                            <div class="tdbox">营业执照</div>
                            <div class="tdbox">
                                <el-upload ref="upload" style="margin-left:57px;"
                                    class="upload-demo"
                                           :action="$baseURL + '/api/home/upload/file/award_log'"
                                    :data="{ token: token }"
                                    :show-file-list="false"
                                    accept=".png, .jpg"
                                    :on-remove="handleRemove"
                                    :file-list="fileList"
                                    :on-success="handleAdd"
                                    :on-error="handleError"
                                    list-type="text"
                                    :limit="1">
                                <img
                                    class="certifications"
                                    v-if="ruleForm.business_license"
                                    :src="ruleForm.business_license"
                                    alt="" />
                                <div class="business" v-if="!ruleForm.business_license">
                                    <img class="Businesscertificate"
                                        src="@/assets/6952@2x.png"
                                        alt="" />
                                    <p style="color: #9fa5ae; font-size: 16px" >
                                        未上传营业执照
                                    </p>
                                </div>
                                </el-upload>
                            </div>
                        </div>
                    </div> -->
                </div>
                <div class="tablebox">
                    <div class="thbox-260">
                        <div class="tdbox">统一社会信用代码<span style="color: #FF4D4D">*</span></div>
                        <div class="tdbox">
                            <el-input v-model="ruleForm.unified_social_credit_code" size="small" class="inpyabeb" placeholder="请输入统一社会信用代码"></el-input>
                        </div>
                    </div>
                    <div class="thbox-260">
                        <div class="tdbox">法定代表人<span style="color: #FF4D4D">*</span></div>
                        <div class="tdbox">
                            <el-input v-model="ruleForm.legal_representative" size="small" class="inpyabeb" placeholder="请输入法定姓名"></el-input>
                        </div>
                    </div>
                    <div class="thbox-142" style="width:194px;">
                        <div class="tdbox">证件号<span style="color: #FF4D4D">*</span></div>
                        <div class="tdbox">
                            <el-input v-model="ruleForm.legal_representative_id" size="small" class="inpyabeb" placeholder="请输入法人身份证号"></el-input>
                        </div>
                    </div>
                    <div class="thbox-142">
                        <div class="tdbox">企业类型<span style="color: #FF4D4D">*</span></div>
                        <div class="tdbox">
                            <el-select v-model="ruleForm.name_of_branch_of_enterprise_entering_guizhou"
                                       placeholder="请选择企业类型"
                                       class="inpyabeb"
                                       size="small">
                                <el-option label="管道燃气" value="管道燃气"></el-option>
                                <el-option label="瓶装燃气" value="瓶装燃气"></el-option>
                                <el-option label="设备供应商" value="设备供应商"></el-option>
                                <el-option label="设计单位" value="设计单位"></el-option>
                                <el-option label="施工单位" value="施工单位"></el-option>
                                <el-option label="监理单位" value="监理单位"></el-option>
                                <el-option label="咨询服务" value="咨询服务"></el-option>
                                <el-option label="地方协会" value="地方协会"></el-option>
                                <el-option label="大专院校" value="大专院校"></el-option>
                                <el-option label="其他" value="其他"></el-option>
                            </el-select>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="tablebox">
            <div class="thbox-142">
                <div class="tdbox">企业性质<span style="color: #FF4D4D">*</span></div>
                <div class="tdbox">
                    <el-select v-model="ruleForm.enterprise_nature" placeholder="请选择企业性质" class="inpyabeb" size="small">
                        <el-option label="事业单位" value="事业单位"></el-option>
                        <el-option label="国有企业" value="国有企业"></el-option>
                        <el-option label="私营企业" value="私营企业"></el-option>
                        <el-option label="中央企业" value="中央企业"></el-option>
                        <el-option label="外商独资企业" value="外商独资企业"></el-option>
                        <el-option label="中外合资企业" value="中外合资企业"></el-option>
                        <el-option label="境外非政府组织的境内代表机构" value="境外非政府组织的境内代表机构"></el-option>
                        <el-option label="个体工商户" value="个体工商户"></el-option>
                        <el-option label="其他" value="其他"></el-option>
                    </el-select>
                </div>
            </div>
            <div class="thbox-142">
                <div class="tdbox">是否上市</div>
                <div class="tdbox">
                    <el-radio-group v-model="islist" size="small" class="inpyabeb">
                        <el-radio label="1">是</el-radio>
                        <el-radio label="0">否</el-radio>
                    </el-radio-group>
                </div>
            </div>
            <div class="thbox-142">
                <div class="tdbox">成立时间<span style="color: #FF4D4D">*</span></div>
                <div class="tdbox">
                    <el-date-picker
                        type="date"
                        value-format="yyyy-MM-dd"
                        format="yyyy-MM-dd"
                        placeholder="选择日期"
                        v-model="ruleForm.established_time"
                        class="inpyabeb"
                    ></el-date-picker>
                </div>
            </div>
            <div class="thbox-142">
                <div class="tdbox">注册资本</div>
                <div class="tdbox">
                    <div class="input" style="display: flex;position: relative;">
                    <el-input-number :controls="false" v-model="ruleForm.registered_capital" size="small" class="inpyabeb" placeholder="请输入注册资本"></el-input-number>
                        <span style="position:absolute;top:4px;right:5px;">万</span>
                    </div>
                </div>
            </div>
            <div class="thbox-284">
                <div class="tdbox">联系电话<span style="color: #FF4D4D">*</span></div>
                <div class="tdbox">
                    <el-input v-model="ruleForm.contact_number" size="small" class="inpyabeb" placeholder="请输入企业联系电话"></el-input>
                </div>
            </div>
        </div>
        <!-- 基本介绍 -->
        <Lineconbgtir :labelcontainer="Corporateinfo" style="margin-top: 20px"/>
        <div class="tablebox" style="margin-top: 16px">
            <div class="thbox-260">
                <div class="tdbox">法定代表人手机号<span style="color: #FF4D4D">*</span></div>
                <div class="tdbox">
                    <el-input v-model="ruleForm.other_phone" size="small" class="inpyabeb" placeholder="请输入手机号"></el-input>
                </div>
            </div>
            <div class="thbox-260">
                <div class="tdbox">文化程度<span style="color: #FF4D4D">*</span></div>
                <div class="tdbox">
                    <el-select
                    v-model="ruleForm.education_degree"
                    placeholder="请选择文化程度"
                    class="inpyabeb"
                    size="small">
                    <el-option label="博士后" value="博士后"></el-option>
                    <el-option label="博士研究生" value="博士研究生"></el-option>
                    <el-option label="硕士研究生" value="硕士研究生"></el-option>
                    <el-option label="大学本科" value="大学本科"></el-option>
                    <el-option label="大专" value="大专"></el-option>
                    <el-option label="高中及以下" value="高中及以下"></el-option>
                </el-select>
                </div>
            </div>
            <div class="thbox-260">
                <div class="tdbox">职业资格水平<span style="color: #FF4D4D">*</span></div>
                <div class="tdbox">
                    <el-select
                        v-model="ruleForm.professional_qualification_level"
                        placeholder="请选择职业资格水平"
                        class="inpyabeb"
                        size="small">
                        <el-option label="无" value="无"></el-option>
                        <el-option label="高级职称" value="高级职称"></el-option>
                        <el-option label="副高级职称" value="副高级职称"></el-option>
                        <el-option label="中级职称" value="中级职称"></el-option>
                        <el-option label="初级职称" value="初级职称"></el-option>
                    </el-select>
                </div>
            </div>
            <div class="thbox-260">
                <div class="tdbox">政治面貌</div>
                <div class="tdbox">
                    <el-select
                    v-model="ruleForm.political_outlook"
                    placeholder="请选择政治面貌"
                    class="inpyabeb"
                    size="small">
                    <el-option label="普通居民" value="普通居民"></el-option>
                    <el-option
                        label="中国共产党党员"
                        value="中国共产党党员"
                    ></el-option>
                    <el-option
                        label="中国共产党预备党员"
                        value="中国共产党预备党员"
                    ></el-option>
                    <el-option
                        label="中国共产主义青年团团员"
                        value="中国共产主义青年团团员"
                    ></el-option>
                    <el-option
                        label="中国国民党革命委员会会员"
                        value="中国国民党革命委员会会员"
                    ></el-option>
                    <el-option
                        label="中国民主同盟盟员"
                        value="中国民主同盟盟员"
                    ></el-option>
                    <el-option
                        label="中国民主建国会会员"
                        value="中国民主建国会会员"
                    ></el-option>
                    <el-option
                        label="中国民主促进会会员"
                        value="中国民主促进会会员"
                    ></el-option>
                    <el-option
                        label="中国农工民主党党员"
                        value="中国农工民主党党员"
                    ></el-option>
                    <el-option
                        label="中国致公党党员"
                        value="中国致公党党员"
                    ></el-option>
                    <el-option
                        label="九三学社社员"
                        value="九三学社社员"
                    ></el-option>
                    <el-option
                        label="台湾民主自治同盟盟员"
                        value="台湾民主自治同盟盟员"
                    ></el-option>
                    <el-option
                        label="无党派民主人士"
                        value="无党派民主人士"
                    ></el-option>
                </el-select>
                </div>
            </div>
            <div class="thbox-260">
                <div class="tdbox">党组织关系所在单位</div>
                <div class="tdbox">
                    <el-input v-model="ruleForm.company" size="small" class="inpyabeb" placeholder="请输入法人党组织所在单位名称"></el-input>
                </div>
            </div>
        </div>
        <Lineconbgtir
            :labelcontainer="{ lable: '联系人信息', desc: 'contact information' }"
            style="margin-top: 20px"
        />
        <div class="tablebox" style="margin-top: 16px">
            <div class="thbox-142">
                <div class="tdbox">姓名<span style="color: #FF4D4D">*</span></div>
                <div class="tdbox">
                    <el-input v-model="ruleForm.contact_user_name" size="small" class="inpyabeb" placeholder="请输入联系人姓名"></el-input>
                </div>
            </div>
            <div class="thbox-142">
                <div class="tdbox">工作部门<span style="color: #FF4D4D">*</span></div>
                <div class="tdbox">
                    <el-input v-model="ruleForm.contact_work_department" size="small" class="inpyabeb" placeholder="请输入工作部门"></el-input>
                </div>
            </div>
            <div class="thbox-142">
                <div class="tdbox">职务<span style="color: #FF4D4D">*</span></div>
                <div class="tdbox">
                    <el-input v-model="ruleForm.contact_post" size="small" class="inpyabeb" placeholder="请输入联系人职务"></el-input>
                </div>
            </div>
            <div class="thbox-142">
                <div class="tdbox">固定电话</div>
                <div class="tdbox">
                    <el-input v-model="ruleForm.contact_fixed_telephone" size="small" class="inpyabeb" placeholder="请输入联系电话"></el-input>
                </div>
            </div>
            <div class="thbox-142">
                <div class="tdbox">移动电话<span style="color: #FF4D4D">*</span></div>
                <div class="tdbox">
                    <el-input v-model="ruleForm.contact_mobile_phone" size="small" class="inpyabeb" placeholder="请输入移动电话"></el-input>
                </div>
            </div>
        </div>
        <Lineconbgtir :labelcontainer="{ lable: '基本介绍', desc: 'basic introduction' }" style="margin-top: 20px"/>
        <p style="text-align: start; margin-top: 16px; line-height: 30px">
            <div class="form_textarea">
                <textarea cols="30" rows="10" placeholder="请输入单位相关基本介绍信息..." v-model="ruleForm.introduce"></textarea>
            </div>
        </p>
            <el-button
                type="primary"
                icon="el-icon-edit"
                @click="submitForm('save')"
                class="block-submit">保存资料</el-button>
        <el-button
            type="primary"
            icon="el-icon-check"
            @click="submitForm('submit')"
            class="block-submit">提交资料</el-button>
        </el-form>
    </div>
</template>

<script>
import Lineconbgtir from "./Line"
import {GetMember, PrizeList, UpdataMember} from "../../utils/api.js";
import {validUser} from "../../utils/user.js";

export default {
    name: "ForgetHit",
    components: {
        Lineconbgtir,
    },
    props: ["member"],
    data() {
        return {
            islist: "0",
            labelcontaineragain: {
                lable: "企业信息",
                desc: "Corporate Information",
            },
            Corporateinfo: {
                lable: "法人信息",
                desc: "Legal representative information",
            },
            title: "贵州华盈建筑集团",
            fileList:[],
            token: "",
            ruleForm: {
                name:"",
                enterprise_name: "",
                contact_number: "",
                unified_social_credit_code: "",
                enterprise_nature: "",
                economic_type: "",
                is_list: 0,
                established_time: "",
                registered_capital: "",
                legal_representative: "",
                legal_representative_id: "", //法定身份证号
                // Social_name:'',//社会组织名称
                other_phone: "", //法人电话
                job: "", //本组织现任职务
                is_secretary_general: "", //是否秘书长
                is_representative: "", //是否法定代表人
                political_outlook: "", //政治面貌
                education_degree: "", //文化程度
                is_social_worker: "", //是否社工师
                is_employees: "", //是否本组织从业人员
                professional_qualification_level: "", //职业资格水平
                business_license: "",
                is_show: "",
                party_posts: "", //本组织党内职务
                company: "", //党组织关系所在单位
                introduce: "", //基本介绍
                head_portrait: "", //企业标识图
                certifications:"",//上传资质证书
                address: "", //企业地址
                name_of_branch_of_enterprise_entering_guizhou:undefined
            },
        };
    },
    created() {
    },
    async mounted() {
        this.token = "Bearer " + localStorage.getItem("TOKEN");
        let member = await GetMember();
        console.log(789, member);
        this.ruleForm = member;
        delete this.ruleForm.updated_at;
        delete this.ruleForm.created_at;
    },
    methods: {
        submitForm(type) {
            if(type=='submit'){
                //判断必填是否都有了
                if (!validUser(this, this.ruleForm)) {
                    this.$message({
                        message: "请完善必填信息",
                        type: "error",
                    });
                    return;
                }
            }
            console.log('1234');
            this.ruleForm.is_list = this.islist

            UpdataMember(this.ruleForm).then((res) => {
                    this.$message({
                        message: "修改成功",
                        type: "success",
                    });
                    setTimeout(() => {
                      location.reload();
                    }, 500);
                })
                .catch((err) => {
                    this.$message.error(err);
                });
        },
        upLoad(file){
            console.log(file)
        },
        handleAdd(response, file, fileList) {
            console.log(file, fileList);
            // this.fileList[0] = {
            //     name:fileList[0].response.data.originalName,
            //     url:fileList[0].response.data.host + fileList[0].response.data.url
            // }
            this.$set(this.ruleForm, "business_license", fileList[0].response.data.host + fileList[0].response.data.url);
            this.$refs.upload.clearFiles();
        },
        handleError(err, file, fileList) {
        },
        handleRemove(file, fileList) {
            // console.log(file, fileList);
            this.fileList = []
        },
    },
};
</script>
<style lang="less" scoped>
.inpyabeb /deep/ input{
    border: none;
}
.el-input-number > .el-input::after {
    content: var(--el-input-number-unit);
    position: absolute;
    right: 38px;
    color: #8D8D8D;
}
.block-submit{
    background: linear-gradient(90deg, #3D63DF 0%, #3D63DF 10%, #FF8640 100%);
    border-radius: 4px 4px 4px 4px;
}
.infor {
    &-t {
        // padding: 14px;
        padding-top: 14px;
        border-bottom: 1px solid #d4dbdd;

        &-l {
            font-size: 28px;
            color: #181e23;
            display: inline-block;
            padding-bottom: 14px;
            font-weight: bold;
            border-bottom: 2px solid #194abe;
        }

        &-r {
            width: 128px;
            height: 31px;
            background: linear-gradient(90deg, #3D63DF 0%, #3D63DF 10%, #FF8640 100%);
            border-radius: 4px 4px 4px 4px;
            opacity: 1;
            overflow: hidden;
            display: table-cell;
            line-height: 31px;
            cursor: pointer;

            img {
                vertical-align: middle;
            }

            span {
                color: #ffffff;
                font-size: 14px;
            }
        }
    }

    &-c {
        text-align: justify;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        line-height: 32px;
        color: #565656;
        padding: 10px 0px;
    }

    &-img {
        text-align: center;
        padding: 24px 0px 40px 0px;
    }
}

.tablebox {
    display: flex;

    .thbox-337,
    .thbox-260,
    .thbox-570,
    .thbox-288,
    .thbox-289,
    .thbox-142,
    .thbox-597,
    .thbox-857,
    .thbox-284 {
        .tdbox {
            box-sizing: border-box;
            margin: -1px -1px 0 0;
            display: flex;
            align-items: center;
            font-size: 14px;
            overflow: hidden;

            &:nth-child(1) {
                height: 32px;
                background: #f5f9fb;
                height: 32px;
                padding: 0px;
                color: #9FA6AF;
                padding-left: 17px;
                border: 1px solid #d4dedd;
            }

            &:nth-child(2) {
                height: 50px;
                background: #fff;
                color: #333333;
                font-weight: bold;
                font-size: 16px;
                border: 1px solid #d4dedd;
            }

            .certifications {
                height: 112px;
                margin: 0 auto;
            }

            .business {
                cursor: pointer;
                margin: 0 auto;
                width: 150px;
                height: 112px;
                background: #f1f1f1;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: space-evenly;

                .Businesscertificate {
                    width: 97px;
                    height: 72px;
                }
            }
        }
    }

    .thbox-857 {
        width: 857px;
    }

    .thbox-597 {
        width: 597px;
    }

    .thbox-337 {
        width: 337px;
    }

    .thbox-260 {
        width: 260px;
    }

    .thbox-570 {
        width: 570px;
    }

    .thbox-142 {
        width: 143px;
    }

    .thbox-284 {
        width: 284px;
    }

    .thbox-288 {
        width: 260px;

        .tdbox:nth-child(2) {
            height: 130px;
            padding: 0;
        }
    }

    .thbox-289 {
        width: 260px;

        .tdbox:nth-child(2) {
            height: 210px;
            padding: 0;
        }
    }
}

.block-title {
    width: 842px;
    padding-left: 14px;
    background: url("../../assets/6948.png");
    height: 40px;
    font-size: 20px;
    font-weight: bold;
    color: #1852c7;
    text-align: left;
    display: table-cell;
    vertical-align: middle;

    span {
        margin-right: 20px;
    }

    span:nth-child(2) {
        font-size: 14px;
        color: #9fa5ae;
    }
}

.scroll {
    position: relative;
    height: 226px;
    text-align: left;
}
.margin-left-30 {
    margin-left: 30px;
}
.infor-img img {
    width: 454px;
    height: 341px;
}
.form_textarea {
    width: 837px;
    height: 188px;
    display: flex;
    background: #f5f8fb;
    flex-direction: column;
    justify-content: space-evenly;
    padding-left: 20px;
    textarea {
        width: 818px;
        height: 150px;
        background: #ffffff;
        border: none;
        opacity: 1;
        border-radius: 4px;
        padding: 5px 5px;
        box-sizing: border-box;
        color: #000;
        &:focus {
            outline: none;
            border: 1px solid #194abe;
        }
    }
}
/deep/ .el-button--primary:focus, .el-button--primary:hover{
    background: linear-gradient(90deg, #3D63DF 0%, #3D63DF 10%, #FF8640 100%);
    border: none;
}
</style>
